define.alias("ember-basic-dropdown/templates/components/basic-dropdown", "auth/templates/components/basic-dropdown");